var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullAdvertTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21ZM21.752 15.5032C19.7095 16.3528 15.6272 18.1112 9.50529 20.7784C8.51119 21.1737 7.99043 21.5605 7.94303 21.9386C7.86291 22.5777 8.66323 22.8294 9.75306 23.1721C9.9013 23.2187 10.0549 23.267 10.2124 23.3182C11.2846 23.6667 12.7269 24.0745 13.4767 24.0907C14.1569 24.1054 14.916 23.825 15.7541 23.2495C21.474 19.3884 24.4267 17.4368 24.612 17.3947C24.7428 17.365 24.924 17.3277 25.0468 17.4368C25.1696 17.546 25.1575 17.7527 25.1445 17.8081C25.0653 18.1461 21.9237 21.0668 20.2979 22.5783C19.7911 23.0494 19.4316 23.3836 19.3581 23.46C19.1935 23.631 19.0257 23.7927 18.8644 23.9482C17.8683 24.9084 17.1213 25.6285 18.9058 26.8045C19.7633 27.3696 20.4496 27.8369 21.1341 28.3031C21.8818 28.8123 22.6275 29.3201 23.5923 29.9525C23.8381 30.1137 24.0729 30.281 24.3015 30.444C25.1716 31.0643 25.9533 31.6216 26.919 31.5327C27.4802 31.4811 28.0598 30.9534 28.3542 29.3797C29.0499 25.6606 30.4173 17.6024 30.7334 14.2818C30.7611 13.9909 30.7262 13.6185 30.6982 13.4551C30.6703 13.2917 30.6118 13.0588 30.3994 12.8864C30.1478 12.6822 29.7593 12.6392 29.5856 12.6422C28.7958 12.6562 27.584 13.0775 21.752 15.5032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullAdvertTgIcon);
export default __webpack_public_path__ + "static/media/full-advert-tg-icon.9d05abf4140b14b24218d1286b889cf7.svg";
export { ForwardRef as ReactComponent };